module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [(_vm.appointment) ? _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.value
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentDetailRequest.loading || _vm.actionStatus.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "height": "2",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Create new")]), _vm._v(" "), _c('v-tab', [_vm._v("Choose an existing client")]), _vm._v(" "), (_vm.withDependent) ? _c('v-tab', [_vm._v("Dependency details")]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Create a new client\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Full name",
      "hint": "The client's name and surname. e.g.: Jon Snow"
    },
    model: {
      value: (_vm.fullname),
      callback: function($$v) {
        _vm.fullname = $$v
      },
      expression: "fullname"
    }
  }), _vm._v(" "), _c('phone-number-input', {
    attrs: {
      "short-list": ["ZA"],
      "selected-country-code": "ZA"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "email",
      "hint": "e-mail address. e.g.: jon@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.actionRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.set
    }
  }, [_vm._v("Create and assign")])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Choose an existing client\n              ")]), _vm._v(" "), (!_vm.selectedclient) ? _c('client-list', {
    attrs: {
      "initial-text": _vm.fullname,
      "with-create": false,
      "with-action": false
    },
    on: {
      "relationshipselected": _vm.setSelected
    }
  }) : _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [(_vm.selectedclient) ? _c('client-list-item', {
    attrs: {
      "relationship-id": _vm.selectedclient.id,
      "client": _vm.selectedclient.client
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "action",
      "loading": _vm.actionRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.set
    },
    slot: "action"
  }, [_vm._v("\n                    Set client\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedclient = null
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n                  Choose a different user")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.dep
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('input', _vm.appointment)
      }
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "caption pa-1 ma-0",
    attrs: {
      "tile": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n                You can set the patient information specifically for this appointment.\n                Use this if the patient is different from the contact person (e.g.: a dependant)\n                - this will only set the information on this appointment\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Appointment title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Patient full name"
    },
    model: {
      value: (_vm.appointment.full_name),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "full_name", $$v)
      },
      expression: "appointment.full_name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.dep.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveDependent
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "flat": ""
    }
  }, [_c('center', [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "size": "75"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote mb-4"
  }, [_vm._v("Appointment updated")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0;
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd245ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/SetClient.vue
// module id = 1368
// module chunks = 9